import { AfterViewInit, Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material';
import { IDept, CurrentService } from 'dbweb-core';
import { Observable, of } from 'rxjs';
import { debounceTime, startWith } from 'rxjs/operators';
import { BeforeSaveParam, BillComponent } from '../bill/bill.component';
import { UserBack, UserRole, RoleType, ColumnsWithLetter } from './back';
import pinyin from 'pinyin';

interface ModelUserRole {
	UserName: string;
	RoleName: string;
}
@Component({
	selector: 'common-user',
	templateUrl: './user.component.html',
	styleUrls: ['./user.component.scss'],
	providers: [UserBack]
})
export class UserComponent implements OnInit, AfterViewInit {
	@HostBinding('class.c-user') hostClass = true;
	@ViewChild('bill', { static: true })
	bill: BillComponent;
	filterDeptList: Observable<IDept[]>;
	validRoles: UserRole[];
	roles: { [key: string]: boolean } = {};
	roleLists: string[];
	roleLitters: ColumnsWithLetter[];

	readonly roleTypeAlways = RoleType.always;
	constructor(private back: UserBack, private curr: CurrentService) {
		this.beforeSave = this.beforeSave.bind(this);
	}

	ngOnInit() {
		this.back.fetchRoles().subscribe(v => {
			this.validRoles = v;
			this.roleLists = this.validRoles.map(num => num.Name);
			this.roleLitters = map2WithLetter(this.roleLists);
		});
	}

	beforeSave(selft: BillComponent): Observable<BeforeSaveParam> {
		return of({
			record: {
				Password: selft.typeRecord.Password ? btoa(selft.typeRecord.Password) : null,
				Roles: Object.keys(this.roles)
					.filter(v => this.roles[v])
					.map(v => ({
						UserName: selft.typeRecord.Name,
						RoleName: v
					}))
			}
		} as BeforeSaveParam);
	}
	ngAfterViewInit() {
		this.bill.init.subscribe(() => {
			this.bill.formGroup.get('Password').patchValue(null);
			((this.bill.typeRecord.Roles || []) as ModelUserRole[]).forEach(v => {
				this.roles[v.RoleName] = true;
			});

			this.bill.formGroup
				.get('Dept')
				.valueChanges.pipe(startWith(this.curr.data.Dept.Code), debounceTime(500))
				.subscribe(val => {
					this.filterDeptList = this.back.fetchFilterDept(val);
					console.log('åï¼', this.filterDeptList);
				});
		});
		this.bill.onBeforeSave = this.beforeSave;
	}
	roleChange(event: MatCheckboxChange, roleName: string) {
		if (event.checked) {
			this.roles[roleName] = true;
		} else {
			delete this.roles[roleName];
		}
	}
	acronymFun(letter: string) {
		document.querySelector('#' + letter).scrollIntoView(true);
	}
	try() {
		console.log(this.filterDeptList);
	}
}
function map2WithLetter(v: string[]) {
	const mapList = new Map<string, string[]>();
	v.forEach(vv => {
		let headerLetter = pinyin(vv, { style: pinyin.STYLE_FIRST_LETTER }).map(s => s[0])[0];
		if (headerLetter.length > 1) {
			headerLetter = headerLetter[0];
		}
		if (mapList.has(headerLetter)) {
			mapList.get(headerLetter).push(vv);
		} else {
			mapList.set(headerLetter, [vv]);
		}
	});
	// æåº

	const rev = [] as ColumnsWithLetter[];
	mapList.forEach((columns, letter) => {
		rev.push({ Letter: letter, Columns: columns } as ColumnsWithLetter);
	});
	return rev.sort((a, b) => a.Letter.localeCompare(b.Letter));
}
